<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../core/config/constants.js'

defineProps({
  visible: { type: Boolean, default: false },
})
</script>

<template>
  <Transition name="sticky-cta">
    <div v-if="visible" class="sticky-cta-banner">
      <div class="sticky-cta-content">
        <span class="sticky-cta-text">הצטרפות בעלי עסקים</span>
        <RouterLink :to="{ name: ROUTES.JOIN_NETWORK }" class="sticky-cta-button">
          לחץ כאן
        </RouterLink>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.sticky-cta-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 50%, #1e293b 100%);
  border-top: 2px solid rgba(245, 158, 11, 0.4);
  box-shadow:
    0 -4px 20px rgba(0, 0, 0, 0.3),
    0 -1px 0 rgba(245, 158, 11, 0.2);
  padding: 12px 16px;
}

.sticky-cta-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #f59e0b, #fbbf24, #f59e0b, transparent);
}

.sticky-cta-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.sticky-cta-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.sticky-cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 20px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow:
    0 2px 8px rgba(245, 158, 11, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  white-space: nowrap;
}

.sticky-cta-button:hover {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  transform: scale(1.05);
  box-shadow:
    0 4px 12px rgba(245, 158, 11, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

@media (min-width: 768px) {
  .sticky-cta-banner {
    padding: 14px 24px;
  }

  .sticky-cta-content {
    gap: 24px;
  }

  .sticky-cta-text {
    font-size: 16px;
  }

  .sticky-cta-button {
    padding: 10px 28px;
    font-size: 14px;
    border-radius: 24px;
  }
}

@media (min-width: 1024px) {
  .sticky-cta-banner {
    padding: 16px 32px;
  }

  .sticky-cta-content {
    gap: 32px;
  }

  .sticky-cta-text {
    font-size: 18px;
  }

  .sticky-cta-button {
    padding: 12px 36px;
    font-size: 15px;
    border-radius: 28px;
  }
}

.sticky-cta-enter-active,
.sticky-cta-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.sticky-cta-enter-from,
.sticky-cta-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.sticky-cta-enter-to,
.sticky-cta-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
